"use strict";
import { postRequest, getRequest } from "@/services/RequestService";

export const login = async (credential) => {
  return await postRequest("/auth/login", credential, false);
};

export const checkAuth = async () => {
  try {
    const response = await getRequest("/auth/token");

    return response.data.success;
  } catch (e) {
    const res = false;
    localStorage.clear();
    return res;
  }
};

export const user = async () => {
  return await JSON.parse(localStorage.getItem("user_details"));
};

export const checkUserRole = async () => {
  let userDetails = await user();
  return userDetails.roles.id === 4;
};

export const checkLoggedInUserRole = async () => {
  let userDetails = await user();
  return userDetails.roles;
};

export const logout = async () => {
  try {
    let response = await postRequest("/auth/logout", {});
    return response;
  } catch (e) {
    console.log(e);
    return false;
  }
};
